import { createContext } from 'react';
import type { AuthSession } from '@/api/auth';
import type { UserProfile } from '@/types';

export interface AuthContextValue {
  user: UserProfile | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  photoUrl: string | null;
  login: (data: AuthSession) => void;
  logout: () => void;
  patchUser: (patch: Partial<UserProfile>) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
